// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/session/flagred.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/session/attention.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitles{
    position: relative; /*need to correct timeline sizes*/
}

.subtitles_segment{
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    color: #000000;
    margin-bottom: 16px;
}

.subtitles_segment--opponent{
    font-style: italic;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;

    color: #000000;
}

.subtitles_word{
      cursor: pointer;  
}

.subtitles_word--selected{
    background-color: #f002;
}

.subtitles_word--playing{
    color: #f00;
}

.subtitles_word--preplaying{
    color: rgb(253, 66, 66);
}

.subtitles_word--comment{
    border-bottom: 2px solid rgb(84, 119, 201);
}

.subtitles_word--folder{
    border-bottom: 2px solid #f90;
    background-color: rgba(255, 153, 0, 0.08);
}

.subtitles_tooltip{
    position: fixed;
    background: rgba(30, 30, 30, 0.92);
    color: #fff;
    font-size: 12px;
    line-height: 1.5;
    padding: 6px 10px;
    border-radius: 7px;
    max-width: 260px;
    white-space: pre-wrap;
    word-break: break-word;
    pointer-events: none;
    z-index: 99999;
    transform: translate(-50%, -100%);
    margin-top: -6px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.25);
}

.subtitles_word:hover{
    text-decoration: underline;
}

.subtitles_mark{

}

.subtitles_mark-start::before,
.subtitles_word--attention-start::before,
.subtitles_word--redflag-start::before
{
    content: "";
    width: 14px;
    height: 12px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    /*background-image: url("../../assets/session/attention.png");*/
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    position: relative;
    top: 2px;
}

.subtitles_word--attention{
    background-color: rgba(252, 246, 72, 0.312);
}

.subtitles_word--attention-start::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.subtitles_word--redflag{
    background-color: rgba(252, 72, 72, 0.312);
}

.subtitles_word--redflag-start::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.subtitlesContextMenu_position{
    position: fixed;
    z-index: 1;
}

.subtitlesContextMenu{
    display: flex;
    flex-direction: column;
    gap: 1px;
    background: #FFFFFF;
    box-shadow: 0px 4px 58px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    padding: 10px 0px;
    width: fit-content;
    opacity: 1;
}

.subtitlesContextMenu--hide{
    opacity: 0;
    transition-delay: 100ms;
}


.subtitlesContextMenu--main{
    position: absolute;
}

.subtitlesContextMenu--rt{
    right: 0;
    top: 0;
}

.subtitlesContextMenu--rb{
    right: 0;
    bottom: 0;
}

.subtitlesContextMenu--lt{
    left: 0;
    top: 0;
}

.subtitlesContextMenu--lb{
    left: 0;
    bottom: 0;
}

.subtitlesContextMenu_group{
    display: flex;
    flex-direction: column;
    gap: 1px;
    padding-bottom: 11px;
    margin-bottom: 11px;
    border-bottom: 1px solid rgba(152, 159, 201, 0.12);;
}

.subtitlesContextMenu_button{
    display: flex;
    align-items: center;
    gap: 15px;

    min-width: calc(111px + 12px * 2);
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    
    color: #000000;
    padding: 0 12px;
}

.subtitlesContextMenu_button::before{
    content: "";
    width: 13px;
    height: 13px;

    /*background-color: #0004;*/
    
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

.subtitlesContextMenu_button:hover{
    background-color: #F3F6FF;
}

.subtitlesContextMenu_editButton{
    font-style: italic;
    font-weight: 400;
    font-size: 10px;
    line-height: 24px;
    text-decoration-line: underline;
    padding: 0 12px;

    color: #979797;
}

.subtitlesContextMenu_buttonMenu{
    position: relative;
}

.subtitlesContextMenu_buttonMenu .subtitlesContextMenu{
    display: none;
    position: absolute;
    left: calc(100% - 6px);
    top: -10px;
}

.subtitlesContextMenu_buttonMenu:hover .subtitlesContextMenu{
    display: flex;
}

.subtitles_word_editInput{
    width: 100%;
    position: absolute;
    display: inline-block;
    border: none;
    padding: 1px 3px;
    background-color: #E9EAF1;
    border-radius: 5px;
    margin-right: 4px;
    cursor:text;
    pointer-events: all;
    z-index: 1;
}

.subtitles_word_editInput:hover{
    text-decoration: none;
}

.subtitles_word_editInput:focus{
    outline: none;
}

.subtitles_word_editSize{
    padding: 0px 4px;
    opacity: 0;
    cursor: auto;
    pointer-events: none;
    position: relative;
    z-index: -1;
}

.subtitles_word_editWrap{
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/subtitles/Subtitles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB,EAAE,iCAAiC;AACzD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;MACM,eAAe;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;IAC7B,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;AAEA;;AAEA;;;;IAII,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yDAAyD;IACzD,+DAA+D;IAC/D,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,yDAA2D;AAC/D;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,OAAO;IACP,MAAM;AACV;;AAEA;IACI,OAAO;IACP,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;IACpB,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;;IAEZ,2BAA2B;;IAE3B,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;;IAEf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".subtitles{\n    position: relative; /*need to correct timeline sizes*/\n}\n\n.subtitles_segment{\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #000000;\n    margin-bottom: 16px;\n}\n\n.subtitles_segment--opponent{\n    font-style: italic;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #000000;\n}\n\n.subtitles_word{\n      cursor: pointer;  \n}\n\n.subtitles_word--selected{\n    background-color: #f002;\n}\n\n.subtitles_word--playing{\n    color: #f00;\n}\n\n.subtitles_word--preplaying{\n    color: rgb(253, 66, 66);\n}\n\n.subtitles_word--comment{\n    border-bottom: 2px solid rgb(84, 119, 201);\n}\n\n.subtitles_word--folder{\n    border-bottom: 2px solid #f90;\n    background-color: rgba(255, 153, 0, 0.08);\n}\n\n.subtitles_tooltip{\n    position: fixed;\n    background: rgba(30, 30, 30, 0.92);\n    color: #fff;\n    font-size: 12px;\n    line-height: 1.5;\n    padding: 6px 10px;\n    border-radius: 7px;\n    max-width: 260px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    pointer-events: none;\n    z-index: 99999;\n    transform: translate(-50%, -100%);\n    margin-top: -6px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.25);\n}\n\n.subtitles_word:hover{\n    text-decoration: underline;\n}\n\n.subtitles_mark{\n\n}\n\n.subtitles_mark-start::before,\n.subtitles_word--attention-start::before,\n.subtitles_word--redflag-start::before\n{\n    content: \"\";\n    width: 14px;\n    height: 12px;\n    background-image: url(\"../../assets/session/flagred.png\");\n    /*background-image: url(\"../../assets/session/attention.png\");*/\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: inline-block;\n    position: relative;\n    top: 2px;\n}\n\n.subtitles_word--attention{\n    background-color: rgba(252, 246, 72, 0.312);\n}\n\n.subtitles_word--attention-start::before{\n    background-image: url(\"../../assets/session/attention.png\");\n}\n\n.subtitles_word--redflag{\n    background-color: rgba(252, 72, 72, 0.312);\n}\n\n.subtitles_word--redflag-start::before{\n    background-image: url(\"../../assets/session/flagred.png\");\n}\n\n.subtitlesContextMenu_position{\n    position: fixed;\n    z-index: 1;\n}\n\n.subtitlesContextMenu{\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 58px rgba(0, 0, 0, 0.15);\n    border-radius: 12px;\n    padding: 10px 0px;\n    width: fit-content;\n    opacity: 1;\n}\n\n.subtitlesContextMenu--hide{\n    opacity: 0;\n    transition-delay: 100ms;\n}\n\n\n.subtitlesContextMenu--main{\n    position: absolute;\n}\n\n.subtitlesContextMenu--rt{\n    right: 0;\n    top: 0;\n}\n\n.subtitlesContextMenu--rb{\n    right: 0;\n    bottom: 0;\n}\n\n.subtitlesContextMenu--lt{\n    left: 0;\n    top: 0;\n}\n\n.subtitlesContextMenu--lb{\n    left: 0;\n    bottom: 0;\n}\n\n.subtitlesContextMenu_group{\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    padding-bottom: 11px;\n    margin-bottom: 11px;\n    border-bottom: 1px solid rgba(152, 159, 201, 0.12);;\n}\n\n.subtitlesContextMenu_button{\n    display: flex;\n    align-items: center;\n    gap: 15px;\n\n    min-width: calc(111px + 12px * 2);\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    \n    color: #000000;\n    padding: 0 12px;\n}\n\n.subtitlesContextMenu_button::before{\n    content: \"\";\n    width: 13px;\n    height: 13px;\n\n    /*background-color: #0004;*/\n    \n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n.subtitlesContextMenu_button:hover{\n    background-color: #F3F6FF;\n}\n\n.subtitlesContextMenu_editButton{\n    font-style: italic;\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 24px;\n    text-decoration-line: underline;\n    padding: 0 12px;\n\n    color: #979797;\n}\n\n.subtitlesContextMenu_buttonMenu{\n    position: relative;\n}\n\n.subtitlesContextMenu_buttonMenu .subtitlesContextMenu{\n    display: none;\n    position: absolute;\n    left: calc(100% - 6px);\n    top: -10px;\n}\n\n.subtitlesContextMenu_buttonMenu:hover .subtitlesContextMenu{\n    display: flex;\n}\n\n.subtitles_word_editInput{\n    width: 100%;\n    position: absolute;\n    display: inline-block;\n    border: none;\n    padding: 1px 3px;\n    background-color: #E9EAF1;\n    border-radius: 5px;\n    margin-right: 4px;\n    cursor:text;\n    pointer-events: all;\n    z-index: 1;\n}\n\n.subtitles_word_editInput:hover{\n    text-decoration: none;\n}\n\n.subtitles_word_editInput:focus{\n    outline: none;\n}\n\n.subtitles_word_editSize{\n    padding: 0px 4px;\n    opacity: 0;\n    cursor: auto;\n    pointer-events: none;\n    position: relative;\n    z-index: -1;\n}\n\n.subtitles_word_editWrap{\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
